import React, { memo } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { TimeSlotDto } from '@/api/generated/model';

type HourlyThroughputChartProps = {
	data: TimeSlotDto[];
};

const axisStyle = { fontSize: 12, fill: '#B3B3B3' };

// 리셉션 상세 - 시간대별 처리량 (막대 차트)
const HourlyThroughputChart = memo<HourlyThroughputChartProps>(({ data }) => {
	return (
		<ResponsiveContainer width="100%" height={220}>
			<BarChart data={data} margin={{ top: 10, right: 10, bottom: 0, left: 0 }}>
				<CartesianGrid stroke="#F3F3F3" vertical={false} />
				<XAxis dataKey="label" tick={axisStyle} tickLine={false} axisLine={{ stroke: '#F3F3F3' }} tickMargin={12} />
				<YAxis tick={axisStyle} tickLine={false} axisLine={false} width={40} />
				<Tooltip cursor={{ fill: 'rgba(0, 0, 0, 0.04)' }} />
				<Legend iconType="square" wrapperStyle={{ fontSize: 13, paddingTop: 12 }} labelStyle={{ verticalAlign: 'middle' }} />
				<Bar dataKey="checkIn" name="체크인" fill="#4C8DFF" barSize={16} radius={[2, 2, 0, 0]} />
				<Bar dataKey="cancel" name="체크인 취소" fill="#FC7332" barSize={16} radius={[2, 2, 0, 0]} />
			</BarChart>
		</ResponsiveContainer>
	);
});

HourlyThroughputChart.displayName = 'HourlyThroughputChart';

export default HourlyThroughputChart;
